// removed by extract-text-webpack-plugin
module.exports = {"Contact":"src-pages----contact-module---Contact---ddcXD"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/contact.module.css
// module id = 304
// module chunks = 182157378885413